    import React, { useState, useEffect } from 'react';

    // Store your quotes in an array
    const quotes = [
      "The harder you work for something, the greater you'll feel when you achieve it.",
      "Don't watch the clock; do what it does—keep going.",
      "Believe you can and you're halfway there.",
      "Learn from yesterday. Live for today. Hope for tomorrow. – Albert Einstein",
      "You're braver than you believe, and stronger than you seem, and smarter than you think.",
      "Difficult roads often lead to beautiful destinations."
    ];

    const DailyQuote: React.FC = () => {
      const [currentQuote, setCurrentQuote] = useState('');

      useEffect(() => {
        const today = new Date();
        // Use the current day of the year to pick a quote
        const dayOfYear = today.getDate() + 31 * today.getMonth();
        const quoteIndex = dayOfYear % quotes.length;
        setCurrentQuote(quotes[quoteIndex]);
      }, []);

      return (
        <div className="daily-quote-container">
          <p className="daily-quote-text">"{currentQuote}"</p>
        </div>
      );
    };

    export default DailyQuote;